<template>
  <div class="start flex flex-wrap -mx-2">
    <div class="w-full" v-html="legals"></div>
  </div>
</template>

<script>
import endpoints from '../../endpoints'
import axios from 'axios'

export default {
  name: 'AgbBusiness',

  data () {
    return {
      legals: 'wird geladen...'
    }
  },

  created () {
    this.getLegals()
  },

  methods: {
    getLegals () {
      axios.get(endpoints.legalsBusiness)
        .then(({ data }) => {
          this.legals = data.legals
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  ol, ul {
    @apply mt-16;

    &:first-of-type {
      @apply mt-1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/agb/business.vue